import RequirementForm from '@/components/DynamicForm/RequirementForm';
import React, { useEffect, useState } from 'react';
import styles from '@/pages/EntryFormModal/index.less';
import { TCustomField, TDynamicFormConfig } from '@/components/DynamicForm/model';
import { useRequest } from '@@/plugin-request/request';
import { getDynamicForm, listCustomField } from '@/services/DynamicFormRequest';
import { entry, TEntryValue } from '@/services/CampStudyRequest';
import { Batch } from '@/types/camp/study/studentBaseInfoType';
import dayjs from 'dayjs';
import { useModel } from '@@/plugin-model/useModel';
import { ESwitch } from '@/types/interface';
import { Modal } from '@digit-fe/digit-component';
import { Form, message } from 'antd';

export default function EntryFormModal({
  entryValue,
  batch,
  campName,
  open,
  setOpen,
}: {
  entryValue?: TEntryValue[]; // 上次打卡报名信息
  batch: Batch;
  campName: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const [form] = Form.useForm();
  const [dynamicFormConfig, setDynamicFormConfig] = useState<TDynamicFormConfig>();
  const [customFieldList, setCustomFieldList] = useState<TCustomField[]>();
  const { initialState } = useModel('@@initialState');
  const [committing, setCommitting] = useState(false);
  const campId = batch.cardCampId;

  const ignoreFields = [];
  if (initialState?.realname) {
    ignoreFields.push('real_name');
  }

  const { run: getDynamicFormRun } = useRequest(
    () => {
      return getDynamicForm(campId);
    },
    {
      manual: true,
      onSuccess: (data) => {
        setDynamicFormConfig(data);
      },
      onError: (e) => {
        message.error(e.message);
      },
    },
  );

  useEffect(() => {
    if (entryValue) {
      // 这里是数组结构
      entryValue.forEach((item) => {
        if (item.id && item.value) {
          form.setFieldValue(item.id, item.value);
        }
      });
    }
  }, [entryValue]);

  const { run: listCustomFieldRun } = useRequest(
    () => {
      return listCustomField(campId);
    },
    {
      manual: true,
      onSuccess: (data) => {
        setCustomFieldList(data);
      },
      onError: (e) => {
        message.error(e.message);
      },
    },
  );

  const { run: entryRun } = useRequest(
    (formData: TEntryValue[]) => {
      return entry({
        batchId: batch.id,
        entryValue: formData,
      });
    },
    {
      manual: true,
      onSuccess: () => {
        setOpen(false);
        setTimeout(() => {
          window.location.href = `/v2/camp/class/${batch.id}`;
        }, 1000);
        setCommitting(false);
      },
      onError: () => {
        setCommitting(false);
      },
    },
  );

  useEffect(() => {
    getDynamicFormRun();
    listCustomFieldRun();
  }, [campId]);

  const handleOnOk = () => {
    if (committing) {
      return;
    }
    form.validateFields().then((values) => {
      // @ts-ignore
      entryRun(
        dynamicFormConfig?.fields.map((field) => {
          if (field.fieldType === 'real_name') {
            return {
              id: field.id!,
              name: '真实姓名',
              value: initialState?.realname ? initialState?.realname : values[field.id!],
            };
          } else {
            return {
              id: field.id!,
              name: field.customField?.name || '',
              value: values[field.id!],
            };
          }
        }) || [],
      );
    });
  };

  return (
    <Modal
      title="报名打卡营"
      okType="primary"
      open={open}
      onCancel={() => {
        setOpen(false);
      }}
      destroyOnClose
      width={460}
      className={styles.entryFormModal}
      afterClose={() => {
        form.resetFields();
      }}
      footer={[
        <div
          className="com_camp_btn_orange f16"
          style={{ height: 40, margin: '24px 0 10px 0', width: '100%' }}
          onClick={() => handleOnOk()}
        >
          立即报名
        </div>,
      ]}
    >
      <div className={styles.entryFormCard}>
        <div className={styles.entryFormCardBox}>
          <div className={styles.title}>
            {campName} {batch.name}
          </div>
          <div className={styles.entryTime}>
            {dayjs(batch.stTime).format('YYYY年MM月DD日 HH:mm')} 至{' '}
            {dayjs(batch.enTime).format('YYYY年MM月DD日 HH:mm')}
          </div>
          {batch.earlyStudy === ESwitch.OPEN && (
            <div className={styles.entryStudyText}>
              <span>报名后可提前开始学习</span>
            </div>
          )}
        </div>
      </div>
      <div style={{ paddingTop: '16px' }}>
        <RequirementForm
          form={form}
          requirement={{ requirementType: dynamicFormConfig!, customFields: customFieldList || [] }}
          inModal={true}
          ignoreFields={ignoreFields}
          campId={campId}
          customFieldList={customFieldList || []}
          fields={dynamicFormConfig?.fields || []}
        />
      </div>
    </Modal>
  );
}
